import React, { Component } from 'react'
import { Table, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import Preloader from '../../common/Preloader'
import NewHeader from '../../common/NewHeader'
import SideNav from '../../common/SideNav'
import ResultModal from '../../common/Modals/AddSpeciality'
import NewFooter from '../../common/NewFooter'
import functions from '../../utils/functions'
import EditResultModal from '../../common/Modals/EditSpeciality'
import ajax from '../../utils/ajax'
import SweetAlert from 'react-bootstrap-sweetalert'


class NewSpecialities extends Component {

    state = {
        dialog: false,
        edit: false,
        sweetAlert: false,
        confirmAlert:false,
        specialityId:"",
        specialistsList: false
    }

    componentDidMount() {
        this.getSpecialities();
    }

    editRow = (key) => {
        this.setState({
            edit: true,
            specialityName: key.specialityName,
            specialityCode: key.specialityCode,
            specialityId: key.actioned,
            specialityCodeId:key.specialityCodeId
        })
    }

    onCancelDelet = () => {
        this.setState({ sweetAlert: false, doctorId: "" })
    }

    onConfirmed= () => {
        window.location.reload()
    }

    deleteRow = (key) => {
        this.setState({ sweetAlert: true,specialityId:key})
    }

    recievedState = (data) => {
        this.setState({ dialog: data })
    }

    recievedEditState = (data) => {
        this.setState({ edit: data })
    }

    onClickRegister = () => {
        this.setState({
            dialog: true
        })
    }

    confirmDelete = async () => {

        const { specialityId } = this.state

        console.log("jj h hh  hh ",specialityId)
    
        if (specialityId.length > 0) {
    
          const server_response = await ajax.deleteSpeciality(specialityId);

          console.log("jj h hh  hh ",server_response)
    
          if (server_response.status === "OK") {
            this.setState({
              sweetAlert: false,
              confirmAlert:true,
            })
    
          } else {
    
            this.setState({
              sweetAlert: false,
              confirmAlert:false,
            })
    
          }
        } else {
          console.log("Nothing to delete")
        }
    
      }

    getSpecialities = async () => {
        const server_response = await ajax.listSpeciality();
        const tableData = []

        if (server_response.status === "OK") {

            server_response.details.content.map((speciality) =>
                tableData.push({
                    specialityName: speciality.speciality_name,
                    specialityCode: speciality.speciality_code,
                    specialityCodeId: speciality.speciality_category.category_id,
                    specialityCat: speciality.speciality_category.category_name,
                    userId: speciality.created_by.first_name + " " + speciality.created_by.last_name + " - " + speciality.created_by.user_role.role_name,
                    updated: speciality.updated_on.long_date,
                    actioned: speciality.speciality_id,
                }),
            )
            this.setState({
                specialistsList: tableData
            })

        } else {
            // this.setState({
            //     categoryList: "404"
            // })
        }
    }

    render() {


        const columns = [
            {
                title: 'Speciality Name',
                dataIndex: 'specialityName',
            },
            {
                title: 'Speciality Code',
                dataIndex: 'specialityCode',
            },
            {
                title: 'Speciality Category',
                dataIndex: 'specialityCat',
            },
            {
                title: 'Speciality Category Id',
                dataIndex: 'specialityCatId',
                hidden:true
            },
            {
                title: 'Added By ',
                dataIndex: 'userId',
            },
            {
                title: 'Upddated On',
                dataIndex: 'updated',
            },
            {
                title: 'Actions - [ Edit, Delete ]',
                dataIndex: 'actioned',

                className: 'bg-transparent text-right',
                render: (text, records, index) => {
                    return (
                        <div className="text-nowrap">
                            <Tooltip
                                placement="leftTop"
                                title="Edit Category"
                                color="#454B1B"
                                key="#f50"
                                style={{ marginRight: "10px" }}
                            >
                                <button
                                    type="button"
                                    className="btn btn-light text-red"
                                    onClick={() => this.editRow(records)}

                                >
                                    <i className="fa fa-edit" />
                                </button>
                            </Tooltip>

                            <Tooltip
                                placement="leftTop"
                                title="Delet Category"
                                color="#f50"
                                key="#f50"
                            >
                                <button
                                    type="button"
                                    className="btn btn-light text-red"
                                    onClick={() => this.deleteRow(text)}
                                >
                                    <i className="fa fa-trash" />
                                </button>
                            </Tooltip>

                        </div>
                    )
                }
            },

        ].filter(item => !item.hidden)

        return (
            <body>
                {/* <!-- begin app --> */}
                <div class="app">
                    {/* <!-- begin app-wrap --> */}
                    <div class="app-wrap">
                        {/* <!-- begin pre-loader --> */}
                        <Preloader />
                        <NewHeader />
                        <div class="app-container">
                            <SideNav />
                            {/* <!-- begin app-main --> */}
                            <div class="app-main" id="main">
                                {/* <!-- begin container-fluid --> */}
                                <div class="container-fluid">
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-md-12 m-b-30">
                                            {/* <!-- begin page title --> */}
                                            <div class="d-block d-sm-flex flex-nowrap align-items-center">
                                                <div class="page-title mb-2 mb-sm-0">
                                                    <h1>Specialities</h1>
                                                </div>
                                                <div class="ml-auto d-flex align-items-center">
                                                    <nav>
                                                        <ol class="breadcrumb p-0 m-b-0">
                                                            <li class="breadcrumb-item">
                                                                <a href="index.html"><i class="ti ti-home"></i></a>
                                                            </li>
                                                            <li class="breadcrumb-item">
                                                                System Settings
                                                            </li>
                                                            <li class="breadcrumb-item active text-primary" aria-current="page">Specialities</li>
                                                        </ol>
                                                    </nav>
                                                </div>
                                            </div>
                                            {/* <!-- end page title --> */}
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card card-statistics">
                                                <div class="card-body">

                                                    <div class="my-3">
                                                        <button type="button" onClick={this.onClickRegister} class="btn btn-primary">Add Speciality</button>
                                                    </div>

                                                    <div class="datatable-wrapper table-responsive">

                                                        <Table
                                                            columns={columns}
                                                            bordered
                                                            // onChange={this.onchange}
                                                            dataSource={this.state.specialistsList}
                                                            size="small"
                                                            pagination={{ pageSizeOptions: ['10'], showTitle: false, hideOnSinglePage: false }}

                                                        />

                                                        {this.state.dialog ? (
                                                            <ResultModal
                                                                visible={{ visible: true }}
                                                                handleCancel={this.recievedState}
                                                            />
                                                        ) : null}

                                                        {this.state.edit ? (
                                                            <EditResultModal
                                                                visible={{ visible: true, specialityName: this.state.specialityName,specialityCode: this.state.specialityCode, specialityId:this.state.specialityId,specialityCodeId:this.state.specialityCodeId}}
                                                                handleEditCancel={this.recievedEditState}
                                                            />
                                                        ) : null}
                                                        {this.state.sweetAlert ? (
                                                            <SweetAlert
                                                                warning
                                                                showCancel
                                                                confirmBtnText="Yes, delete it!"
                                                                confirmBtnBsStyle={'danger'}
                                                                cancelBtnBsStyle="secondary"
                                                                title="Are you sure?"
                                                                onConfirm={this.confirmDelete}
                                                                onCancel={this.onCancelDelet}
                                                                focusCancelBtn
                                                            >
                                                                This action is cant be undone!
                                                            </SweetAlert>

                                                        ) : null}

                                                        {this.state.confirmAlert ? (
                                                            <SweetAlert
                                                                success
                                                                title="Deleted !"
                                                                onConfirm={this.onConfirmed}
                                                                timeout={2000}
                                                            >
                                                                Deleted Successfully !
                                                            </SweetAlert>
                                                        ) : null}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                </div>
                                {/* <!-- end container-fluid --> */}
                            </div>
                            {/* <!-- end app-main --> */}
                        </div>
                        {/* <!-- end app-container --> */}
                        <NewFooter />
                    </div>
                    {/* <!-- end app-wrap --> */}
                </div>
                {/* <!-- end app --> */}
            </body>
        )
    }
}
export default NewSpecialities